import './styles.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ContactTeam extends Component {
    static propTypes = {};

    render() {
        return (
            <div className="component-contact-team">
                <div className="content container-fluid v2 medium">
                    <h2 className="section-title">MEET THE TEAM</h2>
                    <div className="team-list">
                        <div className="team-member">
                            <div class="image">
                                <img className="member-avatar img-bottom-space" src={require('./images/contact-team-mateusz.jpeg')} />
                            </div>
                            <div className="member-name">Matt Zybaczynski</div>
                            <div className="member-role">Chief Executive Officer</div>
                        </div>
                        <div className="team-member">
                            <div class="image">
                                <img className="member-avatar img-bottom-space" src={require('./images/contact-team-marek.jpg')} />
                            </div>
                            <div className="member-name">Marek Rupala</div>
                            <div className="member-role">Chief Technology Officer</div>
                        </div>
                        <div className="team-member">
                            <div class="image">
                                <img className="member-avatar img-bottom-space" src={require('./images/contact-team-aga.png')} />
                            </div>
                            <div className="member-name">Aga Król</div>
                            <div className="member-role">Creative Lead</div>
                        </div>
                        <div className="team-member">
                            <div class="image">
                                <img className="member-avatar img-bottom-space" src={require('./images/contact-team-michal.jpeg')} />
                            </div>
                            <div className="member-name">Michał Krajewski</div>
                            <div className="member-role">Head of Product</div>
                        </div>
                        <div className="team-member">
                            <div class="image">
                                <img className="member-avatar img-bottom-space" src={require('./images/contact-team-frank.png')} />
                            </div>
                            <div className="member-name">Frank Carvalho</div>
                            <div className="member-role">Chief Marketing Officer</div>
                        </div>
                        <div className="team-member">
                            <div class="image">
                                <img className="member-avatar img-bottom-space" src={require('./images/contact-team-elad.jpg')} />
                            </div>
                            <div className="member-name">Elad Matzliah</div>
                            <div className="member-role">Head of Sales</div>
                        </div>
                        <div className="team-member">
                            <div class="image">
                                <img className="member-avatar img-bottom-space" src={require('./images/contact-team-artur.png')} />
                            </div>
                            <div className="member-name">Artur Grabias</div>
                            <div className="member-role">Head of Community</div>
                        </div>
                    </div>

                </div>
                <img className="section-bg" src={require('./images/contact-team-bg.svg')} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/contact/Team/index.js